@if (userCanProvideServiceChargeDetails) {
<nz-form-item>
  <nz-form-label translate>payment.serviceChargeDetails.label</nz-form-label>
  <nz-form-control>
    <nz-select nzSize="large" nzShowSearch [formControl]="serviceChargeDetailsControl">
      @for (serviceChargeDetail of serviceChargeDetails$ | async; track serviceChargeDetail.id) {
      <nz-option [nzValue]="serviceChargeDetail.id" [nzLabel]="serviceChargeDetail.label"></nz-option>
      }
    </nz-select>
  </nz-form-control>
</nz-form-item>
}
